



















































import { Component, Vue, Watch } from 'vue-property-decorator';
import FieldData from '@/components/infrastructures/functions/fieldData';
import authService from '@/components/domains/authorization/authService';
import { User } from '@/components/domains/authorization/user';
import PrimaryBtn from '@/components/infrastructures/atoms/designed/PrimaryBtn.vue';
import SubBtn from '@/components/infrastructures/atoms/designed/SubBtn.vue';
import GeneralField from '@/components/infrastructures/atoms/GeneralField.vue';
import KawaiiDialog from '@/components/infrastructures/atoms/KawaiiDialog.vue';
import HpSubTitle from '@/components/infrastructures/atoms/text/HpSubTitle.vue';
import HpText from '@/components/infrastructures/atoms/text/HpText.vue';
import HpTitle from '@/components/infrastructures/atoms/text/HpTitle.vue';

@Component({
  components: {
    HpTitle,
    HpText,
    HpSubTitle,
    GeneralField,
    KawaiiDialog,
    SubBtn,
    PrimaryBtn,
  },
})
export default class LoginForm extends Vue {
  // =========================
  // データ
  // =========================
  name = 'LoginForm';

  /** メールアドレス入力 */
  mailAddress = new FieldData()
      .withId('mailAddress')
      .withType('text_field')
      .withLabel(this.$t('メールアドレス').toString());

  /** パスワード入力 */
  password = new FieldData()
      .withId('password')
      .withType('password')
      .withLabel(this.$t('パスワード').toString());

  /** ダイアログ制御 */
  showDialog = false;
  dialogMessage = '';

  /** ご要望のフラグ */
  flg = false;

  // =========================
  // ウォッチャ
  // =========================
  /**
   * showDialog が ON ➔ flg=true
   * showDialog が OFF ➔ キャッシュ無効リロード
   */
  @Watch('showDialog')
  onShowDialog(val: boolean) {
    if (val) {
      this.flg = true;
    } else {
      // location.reload(true) は非推奨のため、
      // タイムスタンプ付き URL でキャッシュバイパス
      window.location.replace(`${location.pathname}?_=${Date.now()}`);
    }
  }

  // =========================
  // メソッド
  // =========================
  /**
   * ログイン処理
   */
  async login() {
    try {
      await authService.login(this.mailAddress.value, this.password.value);
      this.$router.push('/mypage');
    } catch (e) {
      this.dialogMessage = 'ログインに失敗しました。画面を更新してから再度お試しください。';
      this.showDialog = true; // ➔ ウォッチャが動く
    }
  }
}
